<template>
  <CCard>
    <CCardBody>

      <BTabs :active-tab="active_tab">
        <CTab :title="$t('components.basicInformation')">
          <CCardHeader class="p-0">
            <CRow>
              <CCol col="4" style="text-align: start">

                <strong v-if="status_form==0">{{ $t('components.basicInformation') }}</strong>
                <strong v-if="status_form!=0 && selected_product_detail_name== ''">{{
                    $t('components.basicInformation')
                  }}</strong>
                <strong v-if="status_form!=0 && selected_product_detail_name!= ''">{{
                    selected_product_detail_name
                  }}</strong>

              </CCol>
              <CCol col="8" style="text-align: end">
<!--                <CButton   class="mr-1 ml-1"  v-if="unit_model_items.length<2" @click="add_item_automat()" type="submit"-->
<!--                         size="sm" color="secondary">-->
<!--                  {{ $t('components.addProduct') }}-->
<!--                </CButton>-->
                <CButton v-if="status_form==0"  class="mr-1 ml-1"  @click="insert_data()" type="submit"
                         size="sm" color="secondary">
                  {{ $t('buttons.save') }}
                </CButton>
                <CButton v-if="status_form!=0"  class="mr-1 ml-1"  @click="insert_data()" type="primar"
                         size="sm" color="secondary">
                  {{ $t('buttons.save') }}
                </CButton>

                <CButton v-if="status_form!=0" class="mr-1" @click="emptyList()" type="reset" size="sm"
                         color="secondary">
                  {{ $t("buttons.cancel") }}
                </CButton>

                <a href="/dashboard/products/create" target="_blank">
                  <CButton
                      class="mr-1 ml-1"
                      size="sm"
                      color="dark"
                  >
                    <CIcon size="sm" name="cil-plus"></CIcon>
                  </CButton>
                </a>
              </CCol>


            </CRow>
            <!--        </div>-->

            <!-- Right aligned nav items -->
            <!--      </CCollapse>-->
          </CCardHeader>
          <CRow>
            <CCol col="9">
              <CRow>
                <CCol col="9">
                  <CRow>
                    <CCol col="7">
                      <CInput
                          :label="$t('item')"
                          :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"
                          class="required"
                          v-model="name"
                      />
                      <CSelect
                          :label="$t('components.productNature')"
                          :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                          :options="natures_items"
                          :value.sync="selected_nature"
                      >
                        <template #append-content>
                          <CIcon size="sm" v-on:click.native="go_to_add_modal('main_group')"
                                 name="cil-plus"/>
                        </template>
                      </CSelect>

                      <CSelect
                          :label="$t('components.productCategory')"
                          :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                          :options="category_items_filtered"
                          :value.sync="selected_category"

                      >
                        <template #append-content>
                          <CIcon size="sm" v-on:click.native="go_to_add_modal('category')"
                                 name="cil-plus"/>
                        </template>
                      </CSelect>

                      <CSelect
                          :placeholder="$t('components.productUnit')"
                          :value.sync="selected_master_unit"
                          :label="$t('components.baseUnit')"
                          :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                          :options="mature_unit_items"
                      >
                        <template #append-content>
                          <CIcon v-on:click.native="go_to_add_modal('unit')" name="cil-plus"/>
                        </template>
                      </CSelect>

                      <CSelect
                          :label="$t('components.productBrand')"
                          :value.sync="selected_brand"
                          :options="brand_items"
                          :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"

                      >
                        <template #append-content>
                          <CIcon size="sm" v-on:click.native="go_to_add_modal('brand')"
                                 name="cil-plus"/>
                        </template>
                      </CSelect>

                      <CSelect
                          :label="$t('components.specification')"
                          :horizontal="{label: 'col-sm-4', input: 'col-sm-8'}"
                          :options="specification_options"
                          :value.sync="selected_specification"
                      />


                    </CCol>


                    <CCol col="5" class="pr-0">


                      <CSelect
                          :label="$t('components.favourite')"
                          :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                          :options="favourite_options"
                          :value.sync="selected_favourite"

                      />
                      <CSelect
                          :label="$t('components.status')"
                          :options="status_items"
                          :value.sync="selected_status"
                          :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                      />
                      <CSelect
                          :label="$t('components.exitType')"
                          :value.sync="selected_exit_type"
                          :options="exit_type_items"
                          :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"

                      >

                      </CSelect>
                      <CSelect
                          :label="$t('components.productMaintenance')"
                          :value.sync="selected_maintence"
                          :options="maintence_items"
                          :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                      />
<!--                      <CInput-->
<!--                          :label="$t('buyVat')"-->
<!--                          append="%"-->
<!--                          addInputClasses="text-end"-->
<!--v-model="buy_vat"-->
<!--                          :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"-->
<!--                      />-->
                      <CInput
                          :label="$t('sellVat')"
                          append="%"
                          addInputClasses="text-end"
                          v-model="sale_vat"

                          :horizontal="{label: 'col-sm-5', input: 'col-sm-7'}"
                      />
                    </CCol>
                  </CRow>
                  <CRow>
                    <CCol col="12">
                      <CTextarea
                          :label="$t('components.productSummary')"
                          :horizontal="{label: 'col-sm-2', input: 'col-sm-10'}"
                          v-model="description"
                          class="mr-2"
                          rows="2"
                      />
                    </CCol>
                  </CRow>
                </CCol>
                <CCol col="3">

                  <CCard>
                    <!--                      <CCardHeader class="p-1">-->
                    <!--                        {{ $t('components.productStandard') }}-->
                    <!--                      </CCardHeader>-->
                    <CCardBody class="p-1">
                      <CSelect
                          :options="standards_items"
                          :value.sync="selected_standard"
                      >
                        <template #append-content>
                          <CIcon v-on:click.native="add_standard()" name="cil-plus"/>
                        </template>
                      </CSelect>
                      <input-tag v-model="selected_standards" :allow-duplicates="false"
                                 style="min-height: 30px" :read-only="false"></input-tag>
                    </CCardBody>
                    <CCardBody class="p-1">

                      <CSelect
                          :options="licences_items"
                          :value.sync="selected_licence"
                      >
                        <template #append-content>
                          <CIcon v-on:click.native="add_licence()" name="cil-plus"/>
                        </template>
                      </CSelect>
                      <input-tag v-model="selected_licences" :allow-duplicates="false"
                                 style="min-height: 30px" :read-only="false"></input-tag>
                    </CCardBody>
                  </CCard>

                  <!--                    <CCard>-->

                  <!--                      <CCardHeader class="p-1">-->
                  <!--                        {{ $t('components.productCertificate') }}-->
                  <!--                      </CCardHeader>-->


                  <!--                    </CCard>-->
                  <CInputFile

                      v-show="false"
                      ref="file_selector"
                      v-on:change="handleFileUpload"
                  />

                </CCol>
              </CRow>

            </CCol>
            <CCol col="3">

              <label>{{ $t('components.productImage') }}</label>
              <CRow>

                <CCol col="12" class="text-center" v-on:click="open_file_selector()"
                >

                  <CImg height="180px"
                        width="100%"
                        v-model="previewImage"
                        :src="previewImage"
                  />
                </CCol>

                <!--                  <CCol col="6" class="text-center" v-on:click="open_file_selector(2)"-->
                <!--                  >-->

                <!--                    <CImg height="120px"-->
                <!--                          width="120px"-->
                <!--                          v-model="previewImage[1]"-->
                <!--                           :src="previewImage[1]"-->
                <!--                    />-->
                <!--                  </CCol>-->
              </CRow>
              <br>

            </CCol>

          </CRow>

          <CRow>
            <CCol col="12" class="mb-5">
              <InlineTable
                  :items="unit_model_items"
                  :fields="unit_model_fields"
                  border
                  :bus_prefix="bus_prefix"
                  align="center"
                  hover
                  :name_item="name"
                  :selected_row.sync="selected_product_detail"
                  sorter

                  :unit_items="unit_items"
                  :status_items="status_items"

              >

                <template #unit="{item,index}">
                  <td v-if="index==0">
                    <CSelect
                        :placeholder="$t('departmanName')"
                        :value.sync="selected_unit"

                        :options="unit_items"
                    >
                      <template #append-content>
                        <CIcon v-on:click.native="go_to_add_modal('unit')" name="cil-plus"/>
                      </template>
                    </CSelect>
                  </td>
                  <td v-else>
                    <p ></p>

                  </td>

                </template>


              </InlineTable>

            </CCol>

          </CRow>

        </CTab>
        <CTab v-if="status_form != 0" :title="$t('components.extraInformation')">
          <CCardHeader class="p-0">
            <CRow>
              <CCol col="4" style="text-align: start">

                <strong>{{ $t('components.extraInformation') }}</strong>

              </CCol>
              <CCol col="8" style="text-align: end">
                <!--                                <CButton v-if="status_form!=0" class="mr-1" @click="insert_data()" type="primar"-->
                <!--                                         size="sm" color="secondary">-->
                <!--                                    {{ $t('buttons.edit') }}-->
                <!--                                </CButton>-->

                <CButton class="mr-1" type="reset" size="sm" color="secondary">
                  {{ $t("buttons.print") }}
                </CButton>
                <CButton @click="emptyList()" class="mr-1" type="reset" size="sm" color="secondary">
                  Email
                </CButton>

              </CCol>


            </CRow>
            <!--        </div>-->

            <!-- Right aligned nav items -->
            <!--      </CCollapse>-->
          </CCardHeader>

          <CRow>
            <CCol col="12">
              <CDataTable
                  :items="get_unit_model_items"
                  :fields="extra_info_fields"
                  hover
                  border
                  striped

                  pagination
              >
                <template #name="{item}">
                  <td>
                    <p>{{ item.model }}</p>

                  </td>
                </template>
                <template #weight="{item}">
                  <td>
                    <CInput
                            v-on:keypress="isDecimal2($event,item.weight)"

                            v-model="item.weight"/>
                  </td>
                </template>
                <template #width="{item}">
                  <td>
                    <CInput
                            v-on:keypress="isDecimal2($event,item.width)"
                       v-model="item.width"/>
                  </td>
                </template>
                <template #height="{item}">
                  <td>
                    <CInput
                            v-on:keypress="isDecimal2($event,item.height)"

                            v-model="item.height"/>
                  </td>
                </template>
                <template #length="{item}">
                  <td>
                    <CInput
                            v-on:keypress="isDecimal2($event,item.length)"
 v-model="item.length"/>
                  </td>
                </template>
                <template #order_point="{item}">
                  <td>
                    <CInput type="number"
                      v-on:keypress="isNumber($event)" v-model="item.order_point"/>
                  </td>
                </template>
                <template #supply_time="{item}">
                  <td>
                    <CInput type="number"
                      v-on:keypress="isNumber($event)" v-model="item.supply_time"/>
                  </td>
                </template>
                <template #min_order="{item}">
                  <td>
                    <CInput type="number"
                      v-on:keypress="isNumber($event)" v-model="item.min_order"/>
                  </td>
                </template>
                <template #min_inventory="{item}">
                  <td>
                    <CInput type="number"
                      v-on:keypress="isNumber($event)" v-model="item.min_inventory"/>
                  </td>
                </template>
                <template #expire_time="{item}">
                  <td>
                    <CInput type="number"
                      v-on:keypress="isNumber($event)" v-model="item.expire_time"/>
                  </td>
                </template>
                <template #order_point_message="{item}">
                  <td>
                    <CInputCheckbox :checked.sync="item.order_point_message"/>
                  </td>
                </template>
                <template #operation="{item}">
                  <td>
                    <CIcon @click.native="update_extra_data(item)" name="saveNew"
                           class="text-dark"/>
                  </td>
                </template>


              </CDataTable>

            </CCol>

          </CRow>

        </CTab>
        <CTab v-if="status_form != 0" :title="$t('components.price')">

          <AddProductPrice v-if="master_id!=0" :selected_model.sync="selected_product_detail_id"
                           :items="unit_model_items"
                           :master_id="master_id"
                           :fields="unit_model_fields"/>

        </CTab>

        <CTab v-if="status_form != 0" :title="$t('components.images')">
          <CRow class="mb-5">
            <CCol v-for="(item,index) in all_product_images" :key="item.productId" col="3">
              <CCard>
                <CCardHeader class="p-0">
                  <CRow>
                    <CCol col="8" style="text-align: start">

                      <label><strong>{{ item.productName }}</strong></label>

                    </CCol>
                    <CCol col="4" style="text-align: end">

                      <CButton v-if="status_form!=0"  class="mr-1 ml-1"
                               @click="insert_product_image(item)" type="primar"
                               size="sm" color="secondary">
                        {{ $t('buttons.submit') }}
                      </CButton>

                    </CCol>


                  </CRow>

                </CCardHeader>

                <CRow class="m-1 text-center">

                  <vue-upload-multiple-image
                      @upload-success="uploadImageSuccess(index, ...arguments)"
                      @before-remove="beforeRemove(index, ...arguments)"
                      @edit-image="editImage(index, ...arguments)"
                      :data-images="item.files"
                      :maxImage="10"
                      :id-upload="get_image_id(index)"
                      :dragText="get_image_id(index)"
                      browseText="(or) Select"
                      primaryText="Default"
                      markIsPrimaryText="Set as default"
                      popupText="This image will be displayed as default"
                      dropText="Drop your file here ..."
                  ></vue-upload-multiple-image>
                </CRow>
              </CCard>
            </CCol>
          </CRow>
        </CTab>

        <CTab v-if="status_form != 0" :title="$t('sidebars.productCardex')">

          <ProductReportQty :product_master_name="name" :models="unit_model_items"/>

        </CTab>


      </BTabs>

    </CCardBody>
    <AddBaseDataModal/>
  </CCard>
</template>

<script>
import axios from "axios";
import {bus} from '../../../main';
import Treeselect from '@riophae/vue-treeselect'
import AddBaseDataModal from "../includes/AddBaseDataModal";
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import AddProductPrice from "./AddProductPrice";
import ProductReportQty from "./ProductReportQty";
import BTab from "../../tabs/BTab";
import BTabs from "../../tabs/BTabs";
import VueUploadMultipleImage from 'vue-upload-multiple-image'
import InlineTable from "../includes/InlineTable";
import InputTag from 'vue-input-tag'
import Vue from "vue";

export default {
  name: 'Login',
  components: {
    Treeselect,
    InlineTable,
    AddProductPrice,
    ProductReportQty,
    BTabs,
    BTab,
    VueUploadMultipleImage,
    AddBaseDataModal,
    InputTag
  },
  data() {
    return {
      all_product_images: [],
      confirm_delete_name: "confirm" + new Date().getTime() + "_" + this.$vnode.tag,
      selected_product_detail_name: '',
      selected_product_detail: 0,
      bus_prefix: new Date().getTime() + "_" + Math.random() + "_",
      selected_product_detail_id: 0,
      active_tab: 0,
      createdAt: '',
      name: '',
      buy_vat:'20',
      sale_vat:'0',
      file: null,
      color: '#ffffff',
      weight: '',
      barcode: '',
      editable: false,
      previewImage: '/img/placeholder.png',
      product_model: "",
      description: '',
      product_code: '',
      added_product: 0,
      details: [],
      unit_items: [],
      mature_unit_items: [],
      selected_unit: 0,
      selected_master_unit: 0,
      specification_options: [],
      selected_specification: 0,
      favourite_options: [],
      selected_favourite: 0,
      category_items: [],
      category_items_filtered: [],
      selected_category: 0,

      normalizer_category(node) {
        return {
          id: node.catTitleId,
          label: node.catTitle,
          children: node.items,
        }
      },


      brand_items: [],
      selected_brand: 0,

      maintence_items: [],
      selected_maintence: 0,

      exit_type_items: [],
      selected_exit_type: 0,

      standard_licence_items: [],
      standards_items: [],
      selected_standards: [],
      selected_standard: '',
      licences_items: [],
      selected_licences: [],
      selected_licence: '',

      master_id: 0,
      status_items: [],
      selected_status: 0,
      natures_items: [],
      selected_nature: 1,
      collapseDuration: 0,
      status_form: 0,
      gallery: [],
      product_images: [],

      unit_model_fields: [
        {key: 'unit', label: this.$t('picking'), _style: 'width:15%;padding:0px'},
        {key: 'model', label: this.$t('itemName'), _style: 'width:25%;padding:0px'},
        {key: 'barcode', label: this.$t('tables.barcode'), _style: 'width:12%;padding:0px'},
        {key: 'status', label: this.$t('tables.status'), _style: 'width:12%;padding:0px'},
        {key: 'inventory_code', _show: false, label: 'Inventory Code', _style: 'width:15%;padding:0px'},
        {key: 'item_code', _show: false, label: 'Item Code', _style: 'width:10%;padding:0px'},
        {key: 'operation', label: this.$t('tables.operation'), _style: 'width:10%;padding:0px'},
      ],
      extra_info_fields: [
        {key: 'name', label: this.$t('tables.model'), _style: 'width:15%;padding:0px'},

        {key: 'weight', label: this.$t('tables.weight')+"  gr", _style: 'width:9%;padding:0px'},
        {key: 'length', label: this.$t('length')+"  cm", _style: 'width:9%;padding:0px'},

        {key: 'width', label: this.$t('width')+"  cm", _style: 'width:9%;padding:0px'},
        {key: 'height', label: this.$t('height')+"  cm", _style: 'width:9%;padding:0px'},
        {key: 'order_point', label: this.$t('components.productOrderPoint'), _style: 'width:9%;padding:0px'},
        // {key: 'supply_time', label: "مدت زمان تامین", _style: 'width:10%;padding:0px'},
        // {key: 'min_order', label:  this.$t('components.productMinQtySupply'), _style: 'width:9%;padding:0px'},
        {key: 'min_inventory', label:  this.$t('components.productMinQty'), _style: 'width:9%;padding:0px'},
        {key: 'expire_time', label:  this.$t('expire_time'), _style: 'width:10%;padding:0px'},

        {key: 'order_point_message', label:  this.$t('components.productAlertOrderPoint'), _style: 'width:10%;padding:0px'},
        {key: 'operation', label: "", _style: 'width:5%;padding:0px'},
      ],
      unit_model_items: [{
        barcode: "",
        model: "",
        unit: "",
        unit_name: "",
        inventory_code: "",
        item_code: "",
        selected_unit: 0
      }],

    }
  },
  beforeDestroy() {
    console.log("before desroy called")
    bus.$off()
  },

  mounted() {
if(this.get_access("super_market_config")){
  this.unit_model_items[0].selected_unit = 2;
}
    console.log(this.bus_prefix)
    bus.$on('close_add_base_modal', (data) => {
      this.get_base_data();
    });

    bus.$on(this.confirm_delete_name, (data) => {
      // alert(data);
      if (data == "true") {
        this.delete_item();

      } else {
        this.status_form = 0;
      }
    });
    bus.$on('update_price', (data) => {
      // alert(data);
      if (data == "true") {
        this.$router.push({path: "/dashboard/products/edit-price/" + this.added_product});
      } else {
        this.status_form = 0;
      }
    });
    bus.$on(this.bus_prefix + 'inline_table_row_clicked', (data) => {
      if (this.editable && data != 0) {
        this.selected_product_detail_id = this.unit_model_items[data].productId
        this.selected_product_detail_name = this.unit_model_items[data].model
        // this.active_tab = 1
      }

    });

    bus.$on(this.bus_prefix + 'inline_table_row_add', (data) => {
      console.log("add caled", this.bus_prefix)
      if (this.status_form != 0) {
        this.insert_barcode_data(data)
      }
    });

    bus.$on(this.bus_prefix + 'inline_table_row_delete', (data) => {
      console.log("delete called",this.status_form)
      if (this.status_form != 0) {
        console.log("delete called2")

        this.delete_barcode_data(data[0])
      }else{
        this.unit_model_items.splice( data[1],1);

      }
    });

    if (this.$route.params.product_id != null) {
      this.editable = true;
      this.status_form = this.$route.params.product_id;
      this.get_product_data();
      this.active_tab = 4;
    } else {
      this.get_base_data();

    }
  }, watch: {
    '$route.params.product_id': function () {
      this.get_product_data();
    },
    'selected_nature': function () {
     if(this.selected_nature==0){
       this.category_items_filtered = this.category_items;
     }else{
       this.category_items_filtered = this.category_items.filter(x=>x.natureId==this.selected_nature)
     }
      this.selected_category = this.category_items_filtered[0].value
    },


    '$route.path': function () {
      console.log('route changed')
      // this.forceUpdate();
      window.location.reload();
    }
  },
  computed: {
    get_unit_model_items() {
      var items = []
      for (var i = 0; i < this.unit_model_items.length; i++) {
        if (i > 0) {
          items.push(this.unit_model_items[i]);
        }
      }
      return items;
    }
  },
  methods: {
    get_image_id(index) {
      return "image_uploader" + index
    },
    add_item_automat(){

      var item = {};


          item.unit_name = this.mature_unit_items.find(x => x.value === this.selected_master_unit).label;
          item.unit = this.selected_master_unit;
          item.selected_unit = this.selected_master_unit;

      item.productId = 0
      item.barcode= "";
      item.model= this.name + " "+item.unit_name;
      item.inventory_code= "";
      item.item_code= "";


      // console.log("inline adeed" + this.bus_prefix + "inline_table_row_add")
      var add_key = this.bus_prefix + "inline_table_row_add";
      bus.$emit(add_key, item);

      this.unit_model_items.push(item)
    },
    add_standard() {
      if(this.selected_standard!=0){
        this.selected_standards.push(this.selected_standard);

      }
    },
    add_licence() {
      if(this.selected_licence!=0) {
        this.selected_licences.push(this.selected_licence);
      }
    },
    open_file_selector() {
      this.$refs.file_selector.$el.getElementsByTagName('input')[0].click()

    },
    go_to_add_modal(func) {
      bus.$emit("show_add_base_modal", func);

    },
    dataURLtoFile(dataurl, filename) {

      var arr = dataurl.split(','),
          mime = arr[0].match(/:(.*?);/)[1],
          bstr = atob(arr[1]),
          n = bstr.length,
          u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, {type: mime});
    },

    uploadImageSuccess(productId, formData, index, fileList) {
      // console.log('formData', formData)
      // console.log('index', index)
      // console.log('fileList', fileList)
      // console.log('productId', productId)

      this.all_product_images[productId].imgfiles = [];
      // this.all_product_images.filter(x => x.productId = productId)[0].imgIds = [];
      for (var i = 0; i < fileList.length; i++) {

        if (!fileList[i].path.startsWith("http")) {
          this.all_product_images[productId].imgfiles.push(this.dataURLtoFile(fileList[i].path, fileList[i].name));
          // this.all_product_images.filter(x => x.productId = productId)[0].imgIds.push(0);
        }
      }
      // this.all_product_images = fileList;
      // Upload image api
      // axios.post('http://your-url-upload', formData).then(response => {
      //   console.log(response)
      // })
    },
    beforeRemove(productId, index, done, fileList) {
      // console.log('index', index, fileList);
      var r = confirm("remove image");

      this.product_images = fileList;
      if (r == true) {
        this.all_product_images[productId].imgIds.splice(index, 1);
        done()
      } else {

      }
    },
    editImage(productId, formData, index, fileList) {
      this.all_product_images[productId].imgfiles = [];
      // this.all_product_images.filter(x => x.productId = productId)[0].imgIds = [];
      for (var i = 0; i < fileList.length; i++) {
        if (!fileList[i].path.startsWith("http")) {
          this.all_product_images[productId].imgfiles.push(this.dataURLtoFile(fileList[i].path, fileList[i].name));
          // this.all_product_images.filter(x => x.productId = productId)[0].imgIds.push(0);
        }
      }
    },
    get_base_data() {
      this.get_units();
      this.get_categories();
      this.get_brands();
      this.get_natures();
      this.get_statuses();
      // this.get_maintence();
      // this.get_exit_types();
      this.get_standards();
      this.get_sys();
    },
    get_sys() {
      var self = this;

      const formData = new FormData();

      axios.post('GetSysPersonGlobals', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.specification_options = [{label:self.$t('select'),value:0}];
        self.favourite_options = [{label:self.$t('select'),value:0}];
        self.maintence_items = [{label:self.$t('select'),value:0}];
        self.exit_type_items = [];




        content_data.forEach((val) => {
          var obj = {label: val.title, value: val.id}

          if (val.titleType == 6) {
            self.specification_options.push(obj);
          }
          if (val.titleType == 7) {
            self.favourite_options.push(obj);
          }
          if (val.titleType == 24) {
            self.maintence_items.push(obj);
          }
          if (val.titleType == 25) {
            self.exit_type_items.push(obj);
          }
        });

if(self.selected_exit_type==0){
  self.selected_exit_type = self.exit_type_items[0].value
  if(self.get_access('super_market_config')){
    self.selected_exit_type = 86
  }
}

        if(self.selected_specification==0) {
          self.selected_specification = 0
        }
        if(self.selected_favourite==0) {
          self.selected_favourite = 0
        }
        if(self.selected_maintence==0){
          self.selected_maintence = 0
          }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    validateForm: function () {
      this.$root.root_validate_errors = [];

      if (this.name != '' && this.selected_category != 0 && this.unit_model_items.length > 1) {
        return true;
      }

      if (this.name == '') {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertName'));
      }
      if (this.selected_category == 0) {
        this.$root.root_validate_errors.push(this.$t('dialogs.insertCategory'));
      }



      if (this.unit_model_items.length == 1) {
        this.$root.root_validate_errors.push(this.$t('insertOneProduct'));
      }

      return false;
      // e.preventDefault();
    },
    get_style(color) {
      return {
        myStyle: {
          backgroundColor: color
        }
      }
    },
    edit_item(item) {
      this.name = item.unitName;
      this.color = item.color;
      this.description = item.description;
      this.previewImage = item.image;
      this.status_form = item.id;
    },
    emptyList() {
      this.$router.push({path: '/dashboard/products/list'})

    },
    get_natures() {
      var self = this;

      const formData = new FormData();


      // formData.append('id', this.$route.params.cat_id);


      axios.post('GetProductNatures', formData, {}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          self.natures_items = [];
          var obj = {label: self.$t('selectMainGroup'), value: 0}
          self.natures_items.push(obj);
          self.natures_items = self.sort_array(
              self.natures_items, content_data.data,
              'id', 'title');


        } else {
          self.$root.modal_component.show_danger_modal(self.$t("dialogs.error"), content_data.message);

        }


      })
          .catch(function (error) {
            console.log(error);
          });

    },
    get_statuses() {

      var self = this;

      const formData = new FormData();

      axios.post('GetSysPersonGlobals', formData, {withCredentials:true}).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        self.status_items = [];
        // GetProductStatusList
        content_data.forEach((val) => {
          var obj = {label: val.title, value: val.id}

          if (val.titleType == 15) {
            self.status_items.push(obj);
          }

        });


        self.selected_status = self.status_items[0].value

      })
              .catch(function (error) {

                console.log(error);
              });

    },

    get_units() {
      var self = this;
      const formData = new FormData();

      // formData.append('id', this.selected_province);

      axios.post('GetProductUnits', formData, {
        params: {
          // isparent : self.$route.params.cat_id
        },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.unit_items = [];
          self.mature_unit_items = [];
          var obj = {label: self.$t('selectUnit'), value: 0}

          self.unit_items.push(obj);
          self.mature_unit_items.push(obj);
          var unit_parent = content_data.data.filter(x=>x.baseUnitId ==x.id);
          self.mature_unit_items =  self.sort_array(self.mature_unit_items,unit_parent,"id","unitName");
if(self.get_access("super_market_config")){
  self.selected_master_unit = 2

}
          // content_data.data.forEach((val) => {
          //   var obj = {label: val.unitName, value: val.id}
          //
          //   self.unit_items.push(obj);
          // });
          self.unit_items =  self.sort_array(self.unit_items,content_data.data,"id","unitName");


        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);
        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    get_categories() {
      var self = this;

      this.$apis.get_cats().then(result => {
        self.category_items = result
        self.category_items_filtered = self.category_items;

      })

    },
    get_brands() {
      var self = this;

      this.$apis.get_brands(this.$t('noBrand')).then(result => {
        self.brand_items = result

      })


    },
    get_standards() {
      var self = this;


      const formData = new FormData();

      // formData.append('id', this.selected_province);

      axios.post('GetStandardTitleList', formData, {
        params: {
          // isparent : self.$route.params.cat_id
        },
        headers: {
          Authorization: 'Bearer ' + localStorage.getItem('token')
        }
      }).then(function (response) {

        var content_data = response.data;

        // items = content_cats.orders;
        if (content_data.statusCode == 0) {
          // self.items =  content_data.data.map((item, row_id) => { return {...item, row_id}}),
          //         fields;
          self.standards_items = [{label:self.$t('HygieneCertificate'),value:0}];;
          self.selected_standards = [];
          self.licences_items = [{label:self.$t('ISOCertificate'),value:0}];;
          self.selected_licences = [];
          self.standard_licence_items = content_data.data;
          content_data.data.forEach((val) => {
            var obj = {label: val.title, value: val.title}

            if (val.type == 1) {
              self.standards_items.push(obj);

            } else {
              self.licences_items.push(obj);

            }
          });
          self.selected_standard = 0;
          self.selected_licence = 0;

        } else {
          self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

        }

      })
          .catch(function (error) {

            console.log(error);
          });

    },

    get_product_data() {
      console.log("product id " + this.$route.params.product_id);

      let self = this;
      const formData = new FormData();
      let url;
      url = "GetNewProductById";

      formData.append('id', this.status_form);


      axios.post(url, formData, {}).then((res) => {

        self.name = res.data.data.title
        self.master_id = res.data.data.masterId
        self.selected_favourite = res.data.data.favourite
        self.description = res.data.data.summary
        self.weight = res.data.data.weight
        self.selected_unit = res.data.data.productUnitId
        self.selected_brand = res.data.data.brandId
        self.selected_category = res.data.data.catRelId
        self.selected_maintence = parseInt(res.data.data.maintenance)
        self.selected_nature = res.data.data.productNature
        self.selected_exit_type = res.data.data.exitType
        self.selected_status = res.data.data.productStatus
        self.buy_vat = res.data.data.purchaceVAT
        self.sale_vat = res.data.data.saleVAT
        self.selected_master_unit = res.data.data.unitId
        self.barcode = res.data.data.barCode;
        if(res.data.data.imgs.length){
          self.previewImage = self.$root.base_url + "/" + res.data.data.imgs[0].imageName

        }else{
          self.previewImage = '/img/placeholder.png';
        }
        self.createdAt = res.data.data.createdAt
        self.unit_model_items = [{
          barcode: "",
          model: "",
          unit: "",
          unit_name: "",
          inventory_code: "",
          item_code: "",
          selected_unit: 0
        }];
        for (var x = 0; x < res.data.data.barCodes.length; x++) {
          self.unit_model_items.push({
            barcode: res.data.data.barCodes[x].barCode,
            productId: res.data.data.barCodes[x].productId,
            model: res.data.data.barCodes[x].productName,
            unit: res.data.data.barCodes[x].productUnitId,
            unit_name: res.data.data.barCodes[x].productUnitName,
            inventory_code: res.data.data.barCodes[x].inventoryCode,
            item_code: res.data.data.barCodes[x].productCode,
            status: res.data.data.barCodes[x].itemStatus,
            weight: res.data.data.barCodes[x].weight,

          });

        }
        for (x = 0; x < res.data.data.productExtraInfos.length; x++) {


          var filtered_item = self.unit_model_items.filter(itemx => itemx.productId == res.data.data.productExtraInfos[x].productId)[0];
          // console.log(filtered_item)
          if (filtered_item != null) {
            filtered_item.weight = res.data.data.productExtraInfos[x].weight
            filtered_item.width = res.data.data.productExtraInfos[x].width
            filtered_item.order_point = res.data.data.productExtraInfos[x].orderPoint
            filtered_item.length = res.data.data.productExtraInfos[x].length
            filtered_item.height = res.data.data.productExtraInfos[x].height
            filtered_item.min_inventory = res.data.data.productExtraInfos[x].purchaceQty
            filtered_item.expire_time = res.data.data.productExtraInfos[x].shelfLife
            filtered_item.min_order = res.data.data.productExtraInfos[x].purchaceQty
            filtered_item.order_point_message=res.data.data.productExtraInfos[x].orderPointAlert

            let index = self.unit_model_items.findIndex(x2 => x2.productId == res.data.data.productExtraInfos[x].productId);
            self.unit_model_items[index] = filtered_item;
          }

        }
        for (x = 0; x < res.data.data.licenseies.length; x++) {
          if (res.data.data.licenseies[x].type == 1) {
            self.selected_standards.push(res.data.data.licenseies[x].title);
          }
          if (res.data.data.licenseies[x].type == 2) {
            self.selected_licences.push(res.data.data.licenseies[x].title);
          }

        }
        // self.get_lists();
        // this.$root.modal_component.show_api_response_modals(res);
        self.get_base_data();
        self.get_product_images();

      })
          .catch(function (error) {
            console.log(error);
          });


    },
    get_product_images() {
      console.log("product id " + this.$route.params.product_id);

      let self = this;
      const formData = new FormData();
      let url;
      url = "GetProductImagesByMasterId";

      formData.append('ProductMasterId', this.master_id);


      axios.post(url, formData, {}).then((res) => {

        self.all_product_images = res.data.data;
        self.all_product_images.forEach((val) => {
          val.imgfiles = [];
          val.files = [];
          val.imgIds = [];
          val.imageItems.forEach((val2) => {
            var image_url = localStorage.getItem("api_address") + "/" + val2.imageName;
            var item_obj = {path: image_url, name: "image.jpg"}
            val.files.push(item_obj);
            val.imgIds.push(val2.imageId)
          });
        });
        console.log(self.all_product_images)
      })
          .catch(function (error) {
            console.log(error);
          });


    },
    insert_product_image(item) {
      console.log("product id ", item);
      if (item.imgIds == null) {
        item.imgIds = [];
      }
      let self = this;
      const formData = new FormData();
      let url;
      url = "AddProductImages";

      formData.append('ProductId', item.productId);
      formData.append('ProductMasterId', this.master_id);
      for (var i = 0; i < item.imgIds.length; i++) {
        formData.append('ImgIds[]', item.imgIds[i]);
      }
      // if(item.imgIds.length ==0){
      //     formData.append('ImgIds', '[]');
      // }
      for (i = 0; i < item.imgfiles.length; i++) {
        formData.append('Files[]', item.imgfiles[i]);
      }


      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);
        self.get_product_images()

      })
          .catch(function (error) {
            console.log(error);
          });


    },


    handleFileUpload(files, e) {
      this.file = e.target.files[0];
      var previewimg = URL.createObjectURL(this.file);
      this.previewImage = previewimg;

    },
    insert_data() {
      if (!this.validateForm()) {
        console.log("validate form is false" + this.validate_errors);
        return true;
      }

      let self = this;
      const formData = new FormData();
      let url;
      if (this.status_form == 0) {
        url = "AddNewProduct";
      } else {
        url = "EditNewProduct";
        formData.append('id', this.master_id)

      }
      // for (var i = 0; i < this.product_images.length; i++) {
      //     formData.append('post_images[]', this.product_images[i].path)
      //
      // }
      var product_models = []
      for (var x = 1; x < this.unit_model_items.length; x++) {
       var barccddd = this.unit_model_items[x].barcode
        if(barccddd==null){barccddd=""}
        var item = {
          "productId": 0,
          "productMasterId": this.master_id,
          "productName": this.unit_model_items[x].model,
          "barCode": barccddd,
          "productUnitId": this.unit_model_items[x].unit,
          "itemStatus": this.unit_model_items[x].status,

          "weight": this.unit_model_items[x].weight,

        }

        product_models.push(item);
      }

      var standards = []
      for (x = 0; x < this.selected_standards.length; x++) {
        item = {
          "License": this.standard_licence_items.find(z => z.title === this.selected_standards[x]).id,
          "LicenseType": 1,

        }
        standards.push(item);
      }
      for (x = 0; x < this.selected_licences.length; x++) {
        item = {
          "License": this.standard_licence_items.find(z => z.title === this.selected_licences[x]).id,
          "LicenseType": 2,

        }
        standards.push(item);
      }


      var model = {
        "master": {
          "masterTitle": this.name,
          "Favourite": this.selected_favourite,
          "productNature": this.selected_nature,
          "catRelId": this.selected_category,
          "maintenance": this.selected_maintence,
          "brandId": this.selected_brand,
          "summary": this.description,
          "saleQty": 0,
          "SaleVAT": this.sale_vat,
          "PurchaceVAT": this.buy_vat,


          "ProductStatus": this.selected_status,
          "UnitId": this.selected_master_unit,
          "purchaceQty": 0,
          "orderPoint": 0,
          "exitType": this.selected_exit_type
        },
        "barCodes": product_models,
        "Licenses": standards,
      };

      if (this.status_form != 0) {
        model.master.id = this.master_id

      }
      formData.append('model', JSON.stringify(model));
      formData.append('IsDefault', this.file);
      formData.append('ProductName', this.name);
      formData.append('CatRelId', this.selected_category);
      formData.append('ProductUnitId', this.selected_unit);
      formData.append('BarCode', this.barcode);
      formData.append('Weight', this.weight);
      formData.append('BrandId', this.selected_brand);
      formData.append('Summary', this.description);
      formData.append('ProductNature', this.selected_nature);
      // formData.append('Color', this.color);
      // formData.append('description', this.description);
      axios.post(url, formData, {}).then((res) => {
        // self.get_lists();
        if (res.data.statusCode == 0) {
          // self.name = '';
          self.added_product = res.data.data.id;

          if (self.status_form == 0) {
            // this.$root.modal_component.show_confirm_modal(self.$t("dialogs.warning"), self.$t('dialogs.insertProductPrice'), [self.$t("dialogs.ok")], 'update_price');
            self.$router.push({path: "/dashboard/products/edit/" + this.added_product});


          } else {
            self.$root.modal_component.show_api_response_modals(res);
            // self.$router.go(-1);
          }

        } else {
          // this.$router.push({path:'/dashboard/products/list'})
          self.$root.modal_component.show_api_response_modals(res);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },
    update_extra_data(item) {
      console.log("validate form is false", item);

      let self = this;
      const formData = new FormData();
      let url;

      url = "AddProductExtraInfo";
      if (!item.width) {
        formData.append('Width', 0);
      } else {
        formData.append('Width', item.width);
      }
      if (!item.height) {
        formData.append('Height', 0);
      } else {
        formData.append('Height', item.height);
      }
      if (!item.length) {
        formData.append('Length', 0);
      } else {
        formData.append('Length', item.length);
      }
      if (!item.weight) {
        formData.append('Weight', 0);
      } else {
        formData.append('Weight', item.weight);
      }
      if (!item.order_point) {
        formData.append('OrderPoint', 0);
      } else {
        formData.append('OrderPoint', item.order_point);
      }
      // if (!item.min_order) {
      //   formData.append('PurchaceQty', 0);
      // } else {
      //   formData.append('PurchaceQty', item.min_inventory);
      // }
      if (!item.min_inventory) {
        formData.append('purchaceQty', 0);
      } else {
        formData.append('purchaceQty', item.min_inventory);
      }
      if (!item.expire_time) {
        formData.append('ShelfLife', 0);
      } else {
        formData.append('ShelfLife', item.expire_time);
      }
        formData.append('OrderPointAlert', item.order_point_message);

      formData.append('ProductId', item.productId);
      formData.append('ProductMasterId', this.master_id);

      axios.post(url, formData, {}).then((res) => {

        self.$root.modal_component.show_api_response_modals(res);

      })
          .catch(function (error) {

            console.log(error);
          });

    },
    insert_barcode_data(item) {
      console.log("validate form is false", item);

      let self = this;
      const formData = new FormData();
      let url;

      url = "AddEditProductBarCode";

      formData.append('ProductMasterId', this.master_id);
      formData.append('ProductName', item.model);
      formData.append('ProductCode', item.item_code);
      formData.append('BarCode', item.barcode);
      formData.append('itemStatus', item.status);
      formData.append('ProductUnitId', item.unit);
      if (item.productId != null) {
        formData.append('ProductId', item.productId);
      } else {
        formData.append('ProductId', 0);
      }

      axios.post(url, formData, {}).then((res) => {


        // self.get_lists();
        if (res.data.statusCode == 0) {

          self.unit_model_items.filter(item2 => item2 == item)[0].productId = res.data.data.productId;
          self.unit_model_items.filter(item2 => item2 == item)[0].inventory_code = res.data.data.inventoryCode;
          self.unit_model_items.filter(item2 => item2 == item)[0].item_code = res.data.data.productCode;


          // console.log(self.unit_model_items);
        } else {
          // this.$router.push({path:'/dashboard/products/list'})
          self.$root.modal_component.show_api_response_modals(res);

        }


      })
          .catch(function (error) {

            console.log(error);
          });

    },

    delete_item_dialog(item) {
      this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessage"), [this.$t("dialogs.ok")], this.confirm_delete_name);

      this.status_form = item.id;

    },
    delete_item() {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DeleteBrand";


      formData.append('id', this.status_form);

      axios.post(url, formData, {}).then((res) => {
        self.$root.modal_component.show_api_response_modals(res);

        self.status_form = 0;

        // self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
    delete_barcode_data(item) {


      let self = this;
      const formData = new FormData()
      let url;
      url = "DelProductBarCode";


      formData.append('ProductId', item.productId);

      axios.post(url, formData, {}).then((res) => {
        //
        self.$root.modal_component.show_api_response_modals(res);
if(self.status_form==item.productId){
  console.log("status form is equal deleted",self.unit_model_items)
  if(self.unit_model_items.filter(x=>x.productId!=item.productId && x.productId!=null ).length>0){

    self.status_form = self.unit_model_items.filter(x=>x.productId!=item.productId && x.productId!=null)[0].productId
    self.$route.params.product_id = self.unit_model_items.filter(x=>x.productId!=item.productId &&  x.productId!=null)[0].productId
    self.get_product_data();
    console.log("unit models is has products",self.status_form,self.$route.params.product_id )

  }else{
    self.$router.go(-1)
  }
}
        // self.status_form = 0;
        // self.get_lists();


      })
          .catch(function (error) {

            console.log(error);
          });
// this.get_categories();
      // this.$router.push({ path: '/posts/'});
    },
  }
}

</script>
<style>
.vue-input-tag-wrapper .new-tag {
  display: none;
}
</style>
